module.exports = __webpack_public_path__ + "static/img/process-1.4b5657a1.png";